/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import photoCreditStyle from './style';

export default function PhotoCredit() {
	let style = photoCreditStyle();

	return (
		<div style={style.outerStyle()}>
			<h1 className='mt-5 nice-header text-center px-3 text-black'>Photo Creators</h1>
			<p className='mt-5 px-3'>Jonathan Borba via unsplash</p>
			<p className='mt-5 px-3'>Karsten Winegeart via unsplash</p>
			<p className='mt-5 px-3'>John Arano via unsplash</p>
			<p className='mt-5 px-3'>Sushil Ghimire via unsplash</p>
			<p className='mt-5 px-3'>Anastase Maragos via unsplash</p>
			<p className='mt-5 px-3'>Scott Webb via unsplash</p>
			<p className='mt-5 px-3'>AJ Alao via unsplash</p>
		</div>
	);
}
